const {$, $$} = window // eslint-disable-line

export class EventFilter {
  constructor(el) {
    this.rootEl = el
    this.filterElements = $$('[data-event-filter-type]', this.rootEl)

    this.filterElements.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault()
        this.toggleFilterView(el)
      })
    })
  }

  toggleFilterView(clickedEl) {
    let elShouldOpen = !clickedEl.classList.contains('event-filter-opened')

    // remove any classes indicating open state
    this.filterElements.forEach(el => {
      el.classList.remove('event-filter-opened')
      this.rootEl.classList.remove(
        `event-filter--${el.dataset['eventFilterType']}-is-open`
      )
    })

    // add open state class
    if (elShouldOpen) {
      clickedEl.classList.add('event-filter-opened')
      this.rootEl.classList.add(
        `event-filter--${clickedEl.dataset['eventFilterType']}-is-open`
      )
    }
  }
}
